/* tslint:disable */
/* eslint-disable */
/**
 * OneAir.AdminPortal
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import {
    ProviderCredentialFormConfiguration,
    ProviderCredentialFormConfigurationFromJSON,
    ProviderCredentialFormConfigurationToJSON,
    ProviderCredentialFormData,
    ProviderCredentialFormDataFromJSON,
    ProviderCredentialFormDataToJSON,
    ProviderCredentialFormValidationData,
    ProviderCredentialFormValidationDataFromJSON,
    ProviderCredentialFormValidationDataToJSON,
} from '../models';

export interface ApiProviderCredentialsProviderCredentialFormConfigurationGetRequest {
    providerId?: string;
}

export interface ApiProviderCredentialsProviderCredentialFormCreatePostRequest {
    providerCredentialFormData?: ProviderCredentialFormData;
}

export interface ApiProviderCredentialsProviderCredentialFormDataGetRequest {
    id?: string;
}

export interface ApiProviderCredentialsProviderCredentialFormUpdatePostRequest {
    providerCredentialFormData?: ProviderCredentialFormData;
}

export interface ApiProviderCredentialsProviderCredentialFormValidatePostRequest {
    providerCredentialFormData?: ProviderCredentialFormData;
}

/**
 * no description
 */
export class ProviderCredentialFormApi extends runtime.BaseAPI {

    /**
     */
    async apiProviderCredentialsProviderCredentialFormConfigurationGetRaw(requestParameters: ApiProviderCredentialsProviderCredentialFormConfigurationGetRequest): Promise<runtime.ApiResponse<ProviderCredentialFormConfiguration>> {
        const queryParameters: runtime.HTTPQuery = {};

        if (requestParameters.providerId !== undefined) {
            queryParameters['providerId'] = requestParameters.providerId;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/ProviderCredentials/ProviderCredentialForm/Configuration`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => ProviderCredentialFormConfigurationFromJSON(jsonValue));
    }

    /**
     */
    async apiProviderCredentialsProviderCredentialFormConfigurationGet(requestParameters: ApiProviderCredentialsProviderCredentialFormConfigurationGetRequest): Promise<ProviderCredentialFormConfiguration> {
        const response = await this.apiProviderCredentialsProviderCredentialFormConfigurationGetRaw(requestParameters);
        return await response.value();
    }

    /**
     */
    async apiProviderCredentialsProviderCredentialFormCreatePostRaw(requestParameters: ApiProviderCredentialsProviderCredentialFormCreatePostRequest): Promise<runtime.ApiResponse<string>> {
        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json-patch+json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/ProviderCredentials/ProviderCredentialForm/Create`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: ProviderCredentialFormDataToJSON(requestParameters.providerCredentialFormData),
        });

        return new runtime.TextApiResponse(response) as any;
    }

    /**
     */
    async apiProviderCredentialsProviderCredentialFormCreatePost(requestParameters: ApiProviderCredentialsProviderCredentialFormCreatePostRequest): Promise<string> {
        const response = await this.apiProviderCredentialsProviderCredentialFormCreatePostRaw(requestParameters);
        return await response.value();
    }

    /**
     */
    async apiProviderCredentialsProviderCredentialFormDataGetRaw(requestParameters: ApiProviderCredentialsProviderCredentialFormDataGetRequest): Promise<runtime.ApiResponse<ProviderCredentialFormData>> {
        const queryParameters: runtime.HTTPQuery = {};

        if (requestParameters.id !== undefined) {
            queryParameters['id'] = requestParameters.id;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/ProviderCredentials/ProviderCredentialForm/Data`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => ProviderCredentialFormDataFromJSON(jsonValue));
    }

    /**
     */
    async apiProviderCredentialsProviderCredentialFormDataGet(requestParameters: ApiProviderCredentialsProviderCredentialFormDataGetRequest): Promise<ProviderCredentialFormData> {
        const response = await this.apiProviderCredentialsProviderCredentialFormDataGetRaw(requestParameters);
        return await response.value();
    }

    /**
     */
    async apiProviderCredentialsProviderCredentialFormUpdatePostRaw(requestParameters: ApiProviderCredentialsProviderCredentialFormUpdatePostRequest): Promise<runtime.ApiResponse<void>> {
        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json-patch+json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/ProviderCredentials/ProviderCredentialForm/Update`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: ProviderCredentialFormDataToJSON(requestParameters.providerCredentialFormData),
        });

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async apiProviderCredentialsProviderCredentialFormUpdatePost(requestParameters: ApiProviderCredentialsProviderCredentialFormUpdatePostRequest): Promise<void> {
        await this.apiProviderCredentialsProviderCredentialFormUpdatePostRaw(requestParameters);
    }

    /**
     */
    async apiProviderCredentialsProviderCredentialFormValidatePostRaw(requestParameters: ApiProviderCredentialsProviderCredentialFormValidatePostRequest): Promise<runtime.ApiResponse<ProviderCredentialFormValidationData>> {
        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json-patch+json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/ProviderCredentials/ProviderCredentialForm/Validate`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: ProviderCredentialFormDataToJSON(requestParameters.providerCredentialFormData),
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => ProviderCredentialFormValidationDataFromJSON(jsonValue));
    }

    /**
     */
    async apiProviderCredentialsProviderCredentialFormValidatePost(requestParameters: ApiProviderCredentialsProviderCredentialFormValidatePostRequest): Promise<ProviderCredentialFormValidationData> {
        const response = await this.apiProviderCredentialsProviderCredentialFormValidatePostRaw(requestParameters);
        return await response.value();
    }

}
